require('slick-carousel');
import mobileDetector from '../helpers/mobile-detector'

if (typeof $ === 'undefined') {
    // variable is accesible from the outside of the scope.
    var $ = require('jquery');
}

export default {
    props: {
        lightbox: {
            type: Boolean,
            default: false
        },
        infinite: {
            type: Boolean,
            default: false
        },
        slidesToShow: {
            type: Number,
            default: 3
        },
        variableWidth: {
            type: Boolean,
            default: false
        },
        centerMode: {
            type: Boolean,
            default: false
        },
        slidesToScroll: {
            type: Number,
            default: 1
        },
        autoplay: {
            type: Boolean,
            default: false,
        },
        autoplaySpeed: {
            type: Number,
            default: 5000,
        },
        tabletOptions: {
            type: Object,
            default: function () {
                return {slidesToShow: 1}
            }
        },
        dots: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            lightboxOpen: false,
            lightboxInitialized: false,
            isLoadedForMobile: false,
            isLoadedForDesktop: false,
        }
    },

    mounted() {
        var is_rtl = false;

        if (undefined !== check.is_rtl) {
            is_rtl = !!check.is_rtl;
        }

        var conf = '';

        if ( is_rtl == true ) {
            var conf = {
                accessibility: false,
                rtl: is_rtl,
                arrows: false,
                draggable: false,
                infinite: this.infinite,
                slidesToShow: this.slidesToShow,
                slidesToScroll: this.slidesToScroll,
                autoplay: this.autoplay,
                dots: this.dots,
                autoplaySpeed: this.autoplaySpeed,
                responsive: [
                    {
                        breakpoint: 900,
                        settings: this.tabletOptions
                    },
                    {
                        breakpoint: 600,
                        settings: $.extend({}, this.tabletOptions, {slidesToShow: 1})
                    }
                ]
            };
        } else {
            var conf = {
                accessibility: false,
                rtl: is_rtl,
                arrows: false,
                draggable: false,
                variableWidth: this.variableWidth,
                centerMode: this.centerMode,
                infinite: this.infinite,
                slidesToShow: this.slidesToShow,
                slidesToScroll: this.slidesToScroll,
                autoplay: this.autoplay,
                dots: this.dots,
                autoplaySpeed: this.autoplaySpeed,
                responsive: [
                    {
                        breakpoint: 900,
                        settings: this.tabletOptions
                    },
                    {
                        breakpoint: 600,
                        settings: $.extend({}, this.tabletOptions, {slidesToShow: 1})
                    }
                ]
            };
        }
        $(this.$refs.carousel).slick(conf);

        $(window).on('resize orientationchange', () => {
            $(this.$refs.carousel).slick('refresh');
            $(this.$refs.carousel).slick('resize');
            if( mobileDetector.isMobile() || this.breakpointTabletPortrait){
                this.updateMobileImages();      
            } else {
                this.updateDesktopImages();
            }
        });
        $(this.$refs.carousel).find('.game-card').on('click', (e) => {            
            const permalink = $(e.currentTarget).data('permalink');
            if( permalink.length ){
                window.location.href = permalink;
            }else{
                e.preventDefault();
            }
        });

        if( mobileDetector.isMobile() || this.breakpointTabletPortrait){
            this.updateMobileImages();      
        }
    },

    methods: {
        afterBreakpointsUpdateMedia(){             
            if( mobileDetector.isMobile() || this.breakpointTabletPortrait){
                setTimeout( this.updateMobileImages, 400 );
            } else {
                setTimeout( this.updateDesktopImages, 400 );               
            }
        },

        updateMobileImages(){  
            // $(this.$refs.carousel).find('.game-card').each((i, el)=>{
            //     let mobileImage = $(el).data('mobile-image');
            //     if( mobileImage.length == 0 ){
            //         return;
            //     }
            //     $(el).css("background-image", "url('" + mobileImage + "')" );
            // });
        },

        updateDesktopImages(){
            // $(this.$refs.carousel).find('.game-card').each((i, el)=>{
            //     let image = $(el).data('image');
            //     if( image.length == 0 ){
            //         return;
            //     }
            //     $(el).css("background-image", "url('" + image + "')" );
            // });
        },

        nextSlides() {
            if (this.$refs.youtube) {
                this.$refs.youtube.player.pauseVideo();
            }
            $(this.$refs.carousel).slick('slickNext');
        },

        prevSlides() {
            if (this.$refs.youtube) {
                this.$refs.youtube.player.pauseVideo();
            }
            $(this.$refs.carousel).slick('slickPrev');
        },

        // Lightbox
        openLightbox(key) {
            if (!this.lightbox) {
                return;
            }

            if (!this.lightboxInitialized) {
                this.lightboxOpen = true;
                this.initializeLightbox(key);
                return EventBus.$emit('TogggleLightbox');
            }

            $(this.$refs.lightbox).slick('slickGoTo', key);
            this.lightboxOpen = true;
            EventBus.$emit('TogggleLightbox');
        },

        closeLightbox() {
            this.lightboxOpen = false;
            EventBus.$emit('TogggleLightbox');
        },

        nextLightboxSlide() {
            $(this.$refs.lightbox).slick('slickNext');
        },

        prevLightboxSlide() {
            $(this.$refs.lightbox).slick('slickPrev');
        },

        initializeLightbox(key) {
            this.$nextTick(() => {
                $(this.$refs.lightbox).slick({
                    arrows: false,
                    infinite: true,
                    initialSlide: key,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                });
            })

            this.lightboxInitialized = true;
        },
    },
}


// WEBPACK FOOTER //
// ./assets/js/components/Carousel.js